module.exports = __webpack_public_path__ + "media/src/img/payment/mobile_operators-00cad8d62e31455a2c94860d288a0b07.png";